{
  "title": "Harmony QMS Operator's Manual",
  "edition": "Version 1.2, 25 October 2026",
  "pdf": {
    "path": "/manual/operators-manual.pdf",
    "bytes": 2318490
  }
}
